import { getWebRTCToken } from './getWebRTCToken';
import { useEffect, useState } from 'react';
import { TelnyxRTC } from '@telnyx/webrtc';

export const useWebRtc = (accountId: number, webrtcProvider?: string) => {
  const [webRTCClient, setWebRTCClient] = useState<TelnyxRTC>();
  const [activeCall, setActiveCall] = useState<any>();

  const initWebRTC = async () => {
    if (!accountId) return;
    if (webrtcProvider === 'vonage') return;
    try {
      const loginToken = await getWebRTCToken(accountId);
      const client = new TelnyxRTC({
        login_token: loginToken,
      });

      await client.connect();
      client.remoteElement = 'remoteAudio';

      client
        .on('telnyx.ready', () => console.log('ready to call'))
        .on('telnyx.notification', (notification: any) => {
          const call = notification.call;

          call.muteAudio();
          if (notification.type === 'callUpdate') {
            if (notification.call.state === 'active') {
            }

          }
          setActiveCall(notification.call);
        });

      client.on('error', (error: any) => {
        console.error('WebRTC Error:', error);
      });

      client.on('callUpdate', (call: any) => {
        console.log(`Call Update: ${call.state}`);
      });

      setWebRTCClient(client);
      console.log('WebRTC client initialized successfully.');
    } catch (error) {
      console.error('Failed to initialize WebRTC client:', error);
    }
  };

  useEffect(() => {
    initWebRTC();
  }, [accountId, webrtcProvider]); // eslint-disable-line react-hooks/exhaustive-deps

  return { webRTCClient, activeCall };
};
